import { render, staticRenderFns } from "./DashboardsPowerBIView.vue?vue&type=template&id=77302850&scoped=true"
import script from "./DashboardsPowerBIView.vue?vue&type=script&lang=js"
export * from "./DashboardsPowerBIView.vue?vue&type=script&lang=js"
import style0 from "./DashboardsPowerBIView.vue?vue&type=style&index=0&id=77302850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77302850",
  null
  
)

export default component.exports